// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"c74a6e9a","404":"464308c5","787":"06ee96fe"}[chunkId] + ".chunk.js";
};